module.exports = {"TXTWCL_SorryX_youXve_made_too_many_de_ELL":{"id":"TXTWCL_SorryX_youXve_made_too_many_de_ELL","defaultMessage":"このお支払い方法での入金回数が多すぎます。"}}